import {
  ErrorsMappingDE,
  ErrorsMappingEN,
} from '@/pages/Seller/SellerDocuments/SellerDocuments.helpers';
import { useTranslation } from 'react-i18next';
import Button from '../Button';
import Tooltip from '../Tooltip/Tooltip';

interface Props {
  errorName: string;
  onClickErrorIsUnclear: () => void;
  isFeedbackSent: boolean;
}

export const ErrorBlock = ({
  errorName,
  onClickErrorIsUnclear,
  isFeedbackSent,
}: Props) => {
  const { i18n, t } = useTranslation();
  const ErrorsMapping =
    i18n.language === 'en' ? ErrorsMappingEN : ErrorsMappingDE;
  return (
    <div className='p-3'>
      <div className='mb-2 whitespace-pre-line'>{ErrorsMapping[errorName]}</div>
      {isFeedbackSent ? (
        <Tooltip
          content={t(
            'It will help us to make this error more clear and transparent.'
          )}
        >
          <span
            className='font-semibold text-gray-700'
            data-testid={`error_${errorName}_thank_you_text`}
          >
            {t('Thank you for your feedback')}
          </span>
        </Tooltip>
      ) : (
        <Button
          styling='outline'
          onClick={onClickErrorIsUnclear}
          data-testid={`error_${errorName}_mark_as_unclear_btn`}
        >
          {t('This error is not clear to me')}
        </Button>
      )}
    </div>
  );
};
